import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import UnitPicker, { renderUnit, renderSize } from '../UnitPicker/UnitPicker';
import * as Styled from '../../Sizes.styles';
export default (function () {
  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      activeUnit = _useState2[0],
      changeUnit = _useState2[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnitPicker, {
    activeUnit: activeUnit,
    changeUnit: changeUnit
  }), /*#__PURE__*/React.createElement(Styled.ResponsiveWrapper, null, /*#__PURE__*/React.createElement(Styled.Table, null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "\xA0"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Chest"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Waist")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, renderSize('XS', activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit(['84 - 89', '33-35'], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit(['69 - 74', '27-29'], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, renderSize('S', activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit(['92 - 97', '36-38'], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit(['76 - 82', '30-32'], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, renderSize('M', activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit(['99 - 104', '39-41'], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit(['84 - 89', '33-35'], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, renderSize('L', activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit(['107 - 112', '42-44'], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit(['92-97', '36-38'], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, renderSize('XL', activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit(['115 - 120', '45-47'], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit(['99 - 104', '39-41'], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, renderSize('XXL', activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit(['112 - 127', '48-50'], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit(['107 - 112', '42-44'], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, renderSize('XXXL', activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit(['130 - 135', '51-53'], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit(['114 - 120', '45-57'], activeUnit)))))));
});